import React from 'react';
import { AlertDetails } from 'pages/Alerts/components/AlertsDetails/AlertDetails';
import { cmAlertTypes } from 'types/cm.alert.constants';
import { SectionContainer } from 'components/Containers/SectionContainer/SectionContainer';
import Label from 'components/form/Label/Label';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { CollapseInfo } from 'pages/SignupPage/Signup2/components/SelfLoanForTUErrors/components/CollapseInfo/CollapseInfo';
import { ReactComponent as ChevronUp } from 'style/_assets/icons/chevron-up.svg';
import { ReactComponent as ChevronDown } from 'style/_assets/icons/chevron-down.svg';
import CollapsibleComponent from 'components/CollapsibleContainer/CollapsibleContainer';
import { Image } from 'components/Image/Image';
import CreditLimitHeader from './components/creditLimit/CreditLimitHeader';
import CreditAccountOverviewBox from './components/creditLimit/CreditAccountOverviewBox';
import CreditAccountTipForCardBox from './components/creditLimit/CreditAccountTipForCardBox';
import ActionsYouCanTake from 'credit_over_limit_actions/ActionsYouCanTake';
import CreditUsageCollapseHeader from './components/creditLimit/CreditUsageCollapseHeader';
import { CREDIT_CARD_VERTICAL } from 'types/mrph.vertical.constants';
import QuaterlyReportNotificationView from './views/QuaterlyReportNotificationView/QuaterlyReportNotificationView';
import AccountPaidNotificationView from './views/AccountPaidNotificationView/AccountPaidNotificationView';
import AccountImprovedNotificationView from './views/AccountImprovedNotificationView/AccountImprovedNotificationView';
import { CUSTOM_CREDIT_MONITORING } from 'components/CatchBeforeFallNotification/CatchBeforeFallNotification.constants';
import CustomMonitoringModule from './views/CustomMonitoringModule';
import { ACCOUNT_QUARTERLY_REPORT } from 'types/notificationsAlerts.constants';
import './NotificationAlertsDetailsModuleView.scss';
import { Button } from 'components/form/Button/Button';
import AccountNowCurrentNotificationView from './views/AccountNowCurrentNotificationView/AccountNowCurrentNotificationView';
import OText from 'components/CText/OText';
import { isEmpty } from 'helpers/string.helper';

const CreditAccountDetailBoxes = props => {
  const { balance, creditLimit, monthlyPayment } = props;
  const limitPercentage = Math.round((balance / creditLimit) * 100);
  return (
    <FlexContainer className={'padLR4 padB16 flex-column'}>
      <CreditAccountOverviewBox
        balance={balance}
        creditLimit={creditLimit}
        monthlyPayment={monthlyPayment}
      />
      {limitPercentage > 30 && (
        <CreditAccountTipForCardBox
          balance={balance}
          creditLimit={creditLimit}
        />
      )}
    </FlexContainer>
  );
};

const CreditLimitCmAlert = props => {
  const {
    creditCardsAccount,
    selectedAlertDetails,
    alertDetailsConfig,
    creditInfo,
    listLinkCallback,
    config,
  } = props;
  const overLimitAccount = creditCardsAccount?.filter(
    acc => acc.name === selectedAlertDetails?.alertDetails?.entityName,
  )[0];

  const nonOverLimitAccounts = creditCardsAccount?.filter(
    acc => acc.idHash !== overLimitAccount?.idHash,
  );

  return (
    <SectionContainer
      className={'cmAlertsDetailsContainer notificationsAlertsDetails'}
    >
      <CreditLimitHeader
        selectedAlertDetails={selectedAlertDetails}
        alertDetailsConfig={alertDetailsConfig}
      />
      <div className="padTB4 bgGrey005"></div>
      <FlexContainer className={'flex-column padL48 padR48 m-padL16 m-padR16'}>
        {overLimitAccount ||
          (!isEmpty(nonOverLimitAccounts) && (
            <Label className={'H4 mSubtitle-1 margT40 m-margT20'}>
              {'Credit usage for this account'}
            </Label>
          ))}

        {overLimitAccount && (
          <CollapseInfo
            title={<CreditUsageCollapseHeader {...overLimitAccount} />}
            context={<CreditAccountDetailBoxes {...overLimitAccount} />}
            iconUp={<ChevronUp />}
            iconDown={<ChevronDown />}
            removePadding
            removecollapsible
          />
        )}

        {!isEmpty(nonOverLimitAccounts) && (
          <CollapseInfo
            onToggleCallBack={() =>
              listLinkCallback({
                clickTile: 'See all my accounts',
                Vertical: CREDIT_CARD_VERTICAL,
              })
            }
            title={
              <FlexContainer className={'format100'}>
                <Label className={' Subtitle-1 mBody-2 primary_text_light'}>
                  {'See all my accounts'}
                </Label>
              </FlexContainer>
            }
            context={
              <>
                {nonOverLimitAccounts?.map(acc => {
                  return (
                    <div className={'format100 padLR16'}>
                      <CollapseInfo
                        title={<CreditUsageCollapseHeader {...acc} />}
                        context={<CreditAccountDetailBoxes {...acc} />}
                        iconUp={<ChevronUp />}
                        iconDown={<ChevronDown />}
                        removePadding
                        removecollapsible
                      />
                    </div>
                  );
                })}
              </>
            }
            iconUp={<Image className={'blueCheveronUp'} />}
            iconDown={<Image className={'blueCheveronDown'} />}
            removePadding
            removecollapsible
          />
        )}
      </FlexContainer>
      <div className="padTB4 bgGrey005"></div>
      <ActionsYouCanTake
        creditInfo={creditInfo}
        listLinkCallback={listLinkCallback}
      />
      <div className="padTB4 bgGrey005"></div>
      <FlexContainer className={'padL48 padR48 m-padL16 m-padR16 flex-column'}>
        <Label className={'H4 mH5 margT40 m-margT20'}>
          {'Frequently asked questions'}
        </Label>
        {config?.notificationAlerts?.creditOverLimit?.frequentlyAskedQuestion?.map(
          question => {
            return (
              <>
                <div className="margT16 bgWhite"></div>
                <FlexContainer className={'bgGray0'}>
                  <CollapsibleComponent
                    isExpanded={false}
                    contentTitle={
                      <Label className={'H5 mSubtitle-1'} tabIndex="-1">
                        {question?.title}
                      </Label>
                    }
                  >
                    <div className={'padL48 padR16 padB24'}>
                      <OText text={question?.body} />
                    </div>
                  </CollapsibleComponent>
                </FlexContainer>
              </>
            );
          },
        )}
      </FlexContainer>
    </SectionContainer>
  );
};

const NotificationAlertsDetailsModuleWrapper = props => {
  const notificationType = props.selectedAlertDetails?.notificationType;
  const alertCategory = props.selectedAlertDetails?.category;
  const alertSubCategory = props.selectedAlertDetails?.alertSubCategory;

  if (
    notificationType === 'CREDIT_MONITORING' &&
    (cmAlertTypes.CARD_OVER_LIMIT === alertCategory ||
      cmAlertTypes.RETAIL_CARD_OVERLIMIT === alertCategory)
  ) {
    return (
      <CreditLimitCmAlert
        creditCardsAccount={props.creditCardsAccount}
        selectedAlertDetails={props.selectedAlertDetails}
        alertDetailsConfig={props.alertDetailsConfig}
        creditInfo={props.creditInfo}
        listLinkCallback={props.listLinkCallback}
        config={props?.config}
      />
    );
  } else if (
    notificationType === 'CREDIT_MONITORING' &&
    cmAlertTypes.PAID_TRADELINE === props.selectedAlertDetails?.category
  ) {
    return <AccountPaidNotificationView {...props} />;
  } else if (alertSubCategory === 'PAST_DUE_CURRENT_TRADE_LINES') {
    return <AccountNowCurrentNotificationView {...props} />;
  } else if (
    notificationType === 'CREDIT_MONITORING' &&
    cmAlertTypes.IMPROVED_ACCOUNT === props.selectedAlertDetails?.category
  ) {
    return <AccountImprovedNotificationView {...props} />;
  } else if (notificationType === CUSTOM_CREDIT_MONITORING) {
    return <CustomMonitoringModule {...props} />;
  } else if (alertSubCategory === ACCOUNT_QUARTERLY_REPORT) {
    return (
      <QuaterlyReportNotificationView
        selectedAlertDetails={props.selectedAlertDetails}
        {...props}
      />
    );
  } else {
    return (
      <AlertDetails
        datatestid={props.datatestid}
        alertDetailsLoading={props.selectedAlertDetailsLoading}
        alertDetailsError={props.selectedAlertDetailsError}
        alertDetailsConfig={props.alertDetailsConfig}
        isMobileView={props.isMobileView}
        showNewTemplate={props.showNewTemplate}
        listLinkCallback={props.listLinkCallback}
      />
    );
  }
};

const NotificationAlertsDetailsModuleView = props => {
  return (
    <>
      <FlexContainer
        justifyBetween
        alignItemsCenter
        className="desktop-tablet-hide padLR16 padB16 margB16 grayShadow16Bottom"
      >
        <FlexContainer>
          <Button
            mrphType="standardBlue"
            rounded="100px"
            onClick={props.goBack}
            style={{ width: 'auto' }}
          >
            View All
          </Button>
        </FlexContainer>
        <FlexContainer className="justify-end">
          <FlexContainer>
            <Button
              mrphType="standardBlue"
              rounded="100px"
              onClick={props?.prevAlert}
              style={{ width: 'auto', padding: '8px' }}
            >
              <Image imgClass="blueCheveronLeft" />
            </Button>
          </FlexContainer>
          <div className="padLR6"></div>
          <FlexContainer>
            <Button
              mrphType="standardBlue"
              rounded="100px"
              onClick={props.nextAlert}
              style={{ width: 'auto', padding: '8px' }}
            >
              <Image imgClass="blueCheveronRight" />
            </Button>
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>

      <NotificationAlertsDetailsModuleWrapper {...props} />
    </>
  );
};

export default NotificationAlertsDetailsModuleView;
